import { Container } from '@pixi/react'
import btn_spin_normal from '../../asset/images/spin/image_bgSpin1.png'
import btn_spin_hover from '../../asset/images/spin/image_bgSpin2.png'
import btn_spin_pressed from '../../asset/images/spin/image_bgSpin2.png'
import btn_spin_disabled from '../../asset/images/spin/btn_spin_disable.png'
import reply from '../../asset/images/spin/image_spin_circle1.png'
import reply2 from '../../asset/images/spin/image_spin_circle2.png'
import icon_stop from '../../asset/images/spin/image_stop.png'

import { Assets } from 'pixi.js'
import { AnimatedSprite } from './AnimatedSprite'
import { soundManager, SoundType, Image, Button } from '@slot-nx/core'
import { useState } from 'react'

Assets.addBundle('SpinButton', {
  btnSpinNormal: { src: btn_spin_normal, loadParser: 'loadTextures' },
  btnSpinHover: { src: btn_spin_hover, loadParser: 'loadTextures' },
  btnSpinDisabled: { src: btn_spin_disabled, loadParser: 'loadTextures' },
  btnSpinPressed: { src: btn_spin_pressed, loadParser: 'loadTextures' },
  reply: { src: reply, loadParser: 'loadTextures' },
  reply2: { src: reply2, loadParser: 'loadTextures' },
  iconStop: { src: icon_stop, loadParser: 'loadTextures' },
})

interface SpinButtonProps {
  x: number
  y: number
  width: number
  height: number
  isSpinning: boolean
  onSpin: () => void
  onSpinning: () => void
  durationInSeconds?: number
  enabled: boolean
}

export const SpinButton = ({
  durationInSeconds = 1.5,
  ...props
}: SpinButtonProps) => {
  const [parentHover, setParentHover] = useState(false)

  return (
    <Container
      x={props.x}
      y={props.y}
      onmouseenter={() => setParentHover(true)}
      onmouseleave={() => setParentHover(false)}
    >
      <Button
        name="spin button"
        x={0}
        y={0}
        width={props.width}
        height={props.height}
        defaultView="btnSpinNormal"
        hoverView="btnSpinHover"
        disabledView="btnSpinDisabled"
        pressedView="btnSpinPressed"
        enabled={props.enabled}
        onPressing={() => {
          soundManager.play(SoundType.spin)
        }}
        onPress={props.isSpinning ? props.onSpinning : props.onSpin}
      />
      {
        props.isSpinning && props.enabled
          ? (
              <Image
                image="iconStop"
                x={props.width / 2}
                y={props.height / 2}
                anchor={0.5}
              />
            )
          : null
      }
      {
        props.enabled
          ? (
              <AnimatedSprite
                image="reply"
                hoverImage="reply2"
                x={props.width / 2}
                y={props.height / 2}
                width={props.width}
                height={props.height}
                isSpinning={props.isSpinning}
                durationInSeconds={durationInSeconds}
                parentHover={parentHover}
              />
            )
          : null
      }

    </Container>
  )
}
